(function () {
  const getInlineSlides = (sliderEl) => {
    if (!sliderEl) return [];
    return Array.from(sliderEl.querySelectorAll('.swiper-slide'));
  };

  const hydrateInlineSlide = (slide) => {
    if (!slide || slide.dataset.inlineHydrated === 'true') return;

    const template = slide.querySelector('.product-inline-media-template');
    if (!template) return;

    slide.appendChild(template.content.cloneNode(true));
    slide.dataset.inlineHydrated = 'true';
  };

  const hydrateInlineAround = (sliderEl, activeIndex) => {
    const slides = getInlineSlides(sliderEl);
    if (!slides.length) return;

    const indexes = new Set([activeIndex - 1, activeIndex, activeIndex + 1]);
    indexes.forEach((index) => {
      if (index >= 0 && index < slides.length) {
        hydrateInlineSlide(slides[index]);
      }
    });
  };

  const prepareInlineSlider = (sliderEl, initialIndex) => {
    if (!sliderEl) return;
    hydrateInlineAround(sliderEl, initialIndex || 0);
  };

  window.ProductInlineMediaLazy = {
    hydrateAround: hydrateInlineAround,
    prepareForSlider: prepareInlineSlider,
  };

  const initProductAccordion = () => {
    const $toggles = $('.product__about-list .about__accordion-toggle');
    if (!$toggles.length) return;

    $toggles.off('click.mainProduct2SingleOpen');
    $toggles.on('click.mainProduct2SingleOpen', function () {
      const $current = $(this);
      const $currentDesc = $current.siblings('.about__accordion-description');
      const isActive = $current.hasClass('active');
      const $group = $current.closest('.product__about-list');

      $group.find('.about__accordion-toggle.active').not($current).each(function () {
        const $other = $(this);
        $other.removeClass('active');
        $other.siblings('.about__accordion-description').stop().slideUp(300);
      });

      if (isActive) {
        $current.removeClass('active');
        $currentDesc.stop().slideUp(300);
      } else {
        $current.addClass('active');
        $currentDesc.stop().slideDown(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper || imagesWrapper.dataset.zoomInit === 'true') return;

    imagesWrapper.dataset.zoomInit = 'true';
    imagesWrapper.addEventListener('click', (event) => {
      if (event.target.closest('.js-image-zoom')) {
        imagesWrapper.classList.toggle('zoom');
      }
    });
  };

  /** variant_picker_v3 的 swiper 初始化 */
  const initVariantSliderV3 = () => {
    const sliders = document.querySelectorAll('.js-product-variant-slider-v3');
    if (!sliders.length || typeof Swiper === 'undefined') return;

    sliders.forEach((slider) => {
      const swiperEl = slider.querySelector('.js-product-variant-group-v3');
      const nextButton = slider.querySelector('.product-form__controls-nav--next');

      if (!swiperEl || !nextButton) return;
      slider.classList.remove('is-swiper-ready');
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

      const scrollSelectedIntoView = (swiperInstance) => {
        const checkedInput = swiperEl.querySelector('input:checked');
        if (!checkedInput) return;

        const slide = checkedInput.closest('.swiper-slide');
        if (!slide) return;

        const slideIndex = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(slide);
        if (slideIndex >= 0) swiperInstance.slideTo(slideIndex);
      };

      const swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextButton,
        },
        on: {
          afterInit: function (swiper) {
            scrollSelectedIntoView(swiper);
            requestAnimationFrame(() => {
              slider.classList.add('is-swiper-ready');
            });
          },
        },
        breakpoints: {
          750: {
            spaceBetween: 10,
          },
        },
      });

      swiperEl.addEventListener('change', () => {
        setTimeout(() => {
          swiperInstance.update();
          scrollSelectedIntoView(swiperInstance);
        }, 0);
      });
    });
  };

  const initFreeGiftSwipers = (root = document) => {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.product__free-gift-swiper').forEach((giftRoot) => {
      const swiperEl = giftRoot.querySelector('.product__free-gift-swiper-inner');
      const nextEl = giftRoot.querySelector('.product__free-gift-nav--next');
      if (!swiperEl || !nextEl) return;

      if (swiperEl.dataset.swiperInit === 'true' && swiperEl.swiper) return;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      const container = swiperEl.closest('.swiper-container');
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      const isAutoplay = container && container.dataset.autoplay === 'true';
      const delay = container ? parseInt(container.dataset.delay, 10) * 1000 || 5000 : 5000;

      swiperEl.dataset.swiperInit = 'true';

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slides.length > 1,
        observer: true,
        observeParents: true,
        autoplay: isAutoplay
          ? {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation: {
          nextEl,
        },
      });
    });
  };

  document.addEventListener('shopify:section:load', (event) => {
    initProductAccordion();
    initZoomImage();
    initVariantSliderV3();
    initFreeGiftSwipers(event.target);
  });

  initProductAccordion();
  initZoomImage();
  initVariantSliderV3();

  const bootFreeGiftSwipers = () => initFreeGiftSwipers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFreeGiftSwipers);
  } else {
    bootFreeGiftSwipers();
  }
})();
